import { useEffect, useState } from 'react'

export const useViewport = () => {
  const [viewport, setViewport] = useState<'mobile' | 'tablet'>('mobile')

  useEffect(() => {
    const mediaMatcher = window.matchMedia('(min-width: 768px)')

    mediaMatcher.onchange = e => {
      if (e.matches) {
        setViewport('tablet')
      } else {
        setViewport('mobile')
      }
    }

    setViewport(mediaMatcher.matches ? 'tablet' : 'mobile')

    return () => {
      mediaMatcher.onchange = () => {}
    }
  }, [])

  return { viewport }
}
